import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

export default function TransitionsModal({ onConfirm, open, isMongoUpdated }) {

  const classes = useStyles();


  return (
    <div>
      <Modal
        open={open}
        disableEnforceFocus={true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
              Multiple faces detected
            </h3>
            <p id="transition-modal-description">
              Multiple faces detected during the test.
            </p>
            {isMongoUpdated !== true && (
              <p style={{ textAlign: "center", marginBottom: "10px" }}>Saving your responses...</p>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              {/* The OK button must always be reachable - if the background violation
                  save (isMongoUpdated) never succeeds (exhausted retries on a bad
                  connection), this used to hide the button entirely with no way to
                  dismiss the modal short of reloading the page. */}
              <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onConfirm}>
                <strong>Ok</strong>
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
